import { useAuth } from '@neotech-solutions-org/neofusion-fe-shared';
import { useSkin } from '../contexts/SkinContext';
import { useMarketplaceConfig } from '../queries/marketplace';
import { isModernTheme } from '../styles/themeUtils';
import useBreakpoints from './useBreakpoints';

const useDisplayContentConfig = () => {
  const { isMobile } = useBreakpoints();
  const { isUserRegistration } = useMarketplaceConfig();
  const { isAuthenticated } = useAuth();
  const { theme } = useSkin();

  const isEndUserMode = isUserRegistration;
  const isModernBranding = isModernTheme(theme);
  const isPublicMobile = !isAuthenticated && isMobile;
  const isAuthMobile = isAuthenticated && isMobile;

  return {
    isEndUserMode,
    isModernBranding,
    isPublicMobile,
    isAuthMobile,
  };
};

export default useDisplayContentConfig;
